export const environment = {
  apiUrl: 'https://admin-test.emts-groupe.fr/api',
  keycloak: {
    url: 'https://auth.emts-groupe.fr',
    realm: 'emts',
    clientId: 'app-admin-front',
  },
};
